import gql from 'graphql-tag';

const query = gql`
    query getCustomerOrders($first: Int, $after: String, $last: Int, $before: String) {
        customer {
            firstName
            tags
            id
            lastName
            emailAddress {
                emailAddress
            }
            orders(first: $first, last: $last, before: $before, after: $after, reverse: true) {
                edges {
                    node {
                        __typename
                        id
                        name
                        financialStatus
                        processedAt
                        shippingLine {
                            title
                        }
                        totalPrice {
                            amount
                            currencyCode
                        }
                        fulfillments(first: 5) {
                            edges {
                                node {
                                    __typename
                                    status
                                    trackingInformation {
                                        number
                                    }
                                }
                            }
                        }
                        lineItems(first: 2) {
                            edges {
                                node {
                                    __typename
                                    variantId
                                    image {
                                        url
                                    }
                                }
                            }
                        }
                        shippingAddress {
                            __typename
                            id
                            company
                            address1
                            address2
                            country
                            city
                            province
                            zip
                        }
                    }
                }
                pageInfo {
                    __typename
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                }
            }
        }
    }
`;

export { query };
